;(function() {
  'use strict'

  Controller.$inject = ["$scope", "projectService", "projectSortService"];
  angular.module('app.core').component('projectGrid', {
    controller: Controller,
    templateUrl: 'project-grid.html',
    bindings: {
      projects: '<',
      onSelect: '&',
      hasSidebar: '<',
      limit: '<',
      preordered: '<',
      variant: '@',
      link: '<',
    },
  })

  /* @ngInject */
  function Controller($scope, projectService, projectSortService) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.$onChanges = rebuild
    ctrl.archive = projectService.promptAndArchive
    ctrl.unarchive = projectService.promptAndUnarchive

    function onInit() {
      $scope.$watchCollection('$ctrl.projects', rebuild)
    }

    function rebuild() {
      var projects = ctrl.projects || []
      if (!ctrl.preordered) {
        projects = projectSortService.sort(projects, projectSortService.DEFAULT)
      }
      ctrl.items = ctrl.limit ? _.take(projects, ctrl.limit) : projects
    }
  }
})()
